/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { FeedbackGridItemViewModelPaginatedResponse } from "../types/FeedbackGridItemViewModelPaginatedResponse.ts";
import { feedbackGridItemViewModelSchema } from "./feedbackGridItemViewModelSchema.ts";

export const feedbackGridItemViewModelPaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => feedbackGridItemViewModelSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<FeedbackGridItemViewModelPaginatedResponse>;
